module.exports = __webpack_public_path__ + "static/media/fly0034.97f67219.webp";